module.exports = __webpack_public_path__ + "img/dell.c2e969ba.png";